import React, { Component } from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import moment from 'moment';
import { titleize } from 'underscore.string';
import SessionStore from 'stores/SessionStore';
import { Translation, withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { BOOKING_ACCESSORIALS } from '../../../config/accessorials';
import { calculatePalletSpaces } from '../../../helpers/shipments';
import { sluggify } from '../../../utils/localization/utils';
import { LoadDimensionFormatter, LoadUnitFormatter, } from '../master/formatters';
const Location = ({ label, location: { name, street, suite_or_apt, city, state, zipcode }, }) => {
    const address = street || name;
    return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", null,
        React.createElement("h4", { className: "text-lg text-grey-dark" }, label),
        React.createElement("div", { className: "mb-4 flex" },
            React.createElement("i", { className: "fa fa-map-marker mr-2" }),
            React.createElement("div", null,
                name && (React.createElement("p", { className: "mb-1 text-grey-dark font-bold my-0" }, name)),
                React.createElement("p", { className: "mb-1" },
                    address,
                    ' ',
                    suite_or_apt && (React.createElement("span", null, t('SUITE_WITH_VALUE', { suite: suite_or_apt })))),
                React.createElement("p", null,
                    city,
                    ", ",
                    state,
                    " ",
                    zipcode)))))));
};
Location.propTypes = {
    label: PropTypes.string,
    location: PropTypes.shape({
        street: PropTypes.string,
        suite_or_apt: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zipcode: PropTypes.string,
    }),
};
class QuoteDetail extends Component {
    renderOrigin() {
        const { quote: { origin }, } = this.props;
        return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement(Location, { label: titleize(t('ORIGIN')), location: origin[0] }))));
    }
    renderDestination() {
        const { quote: { destination }, } = this.props;
        return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement(Location, { label: t('DESTINATION'), location: destination[0] }))));
    }
    renderLoads() {
        const { quote: { loads }, } = this.props;
        if (!loads.length) {
            return null;
        }
        const totalPalletSpaces = calculatePalletSpaces(loads);
        return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", { className: "mb-4" },
            loads.map((load) => (React.createElement("div", null,
                React.createElement("p", { className: "text-lg" },
                    React.createElement(LoadUnitFormatter, { isTotalWeight: true, weight: accounting.format(load.weight), weight_units: load.weight_units })),
                React.createElement("p", { className: "text-lg" },
                    React.createElement("span", null,
                        load.quantity,
                        " ",
                        titleize(t(sluggify(load.type)))),
                    React.createElement("span", null, ", "),
                    React.createElement(LoadDimensionFormatter, { length: load.length, width: load.width, height: load.height, dimensional_units: load.dimensional_units }),
                    load.spaces && (React.createElement("span", null,
                        ",",
                        ' ',
                        t('PALLET_SPACE_WITH_VALUE', {
                            palletSpace: load.spaces,
                        }))))))),
            SessionStore.isAdmin() && (React.createElement("p", { className: "text-lg" }, t('TOTAL_PALLET_SPACE_WITH_VALUE', {
                totalPalletSpace: totalPalletSpaces,
            })))))));
    }
    renderAccessorials() {
        const { quote: { accessorials: currentAcessorials }, } = this.props;
        const keys = Object.keys(currentAcessorials || {});
        if (!keys.length) {
            return null;
        }
        const selectedAccessorials = BOOKING_ACCESSORIALS.filter((a) => keys.includes(a.value));
        return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", null,
            React.createElement("h3", { className: "text-xl mb-2" }, t('ACCESSORIAL', { count: 2 })),
            React.createElement("div", null, selectedAccessorials.map((accessorial) => (React.createElement("div", { className: "mb-2 flex items-center" },
                React.createElement("img", { src: accessorial.picture_url, alt: t(accessorial.localizeLabel), title: t(accessorial.localizeDescription), className: "rounded-full block w-12 h-12 object-cover bg-green border-grey-lighter border-2 border-solid mr-2" }),
                React.createElement("span", null, t(accessorial.localizeLabel ||
                    accessorial.localizeDescription))))))))));
    }
    render() {
        const { quote: { _id, quote_id, total_cost, shipment_type, expiration_date }, } = this.props;
        return (React.createElement(Translation, null, (t, { i18n }) => (React.createElement("div", { className: "bg-white p-4 h-screen", key: "quote-details" },
            React.createElement("div", null,
                React.createElement("h3", { className: "text-xl mb-1" }, quote_id),
                React.createElement("small", { className: "italic mb-2 text-grey-darker" }, t(sluggify(shipment_type))),
                React.createElement("h4", { className: "text-2xl mb-4" },
                    React.createElement("small", null,
                        t('ESTIMATE_WITH_VALUE', {
                            estimate: formatMoney(total_cost),
                        }),
                        ":")),
                React.createElement("small", { className: "text-grey-darker flex items-center" },
                    t('EXPIRES_ON_WITH_VALUE', {
                        date: moment(expiration_date).format('L'),
                    }),
                    "\u00A0"),
                this.renderOrigin(),
                this.renderDestination(),
                this.renderLoads(),
                this.renderAccessorials()),
            React.createElement("div", { className: "actions my-8" },
                React.createElement("a", { href: `/booking/${_id}`, className: "button button-green block text-center" }, t('BOOK_A_SHIPMENT')))))));
    }
}
QuoteDetail.propTypes = {
    quote: PropTypes.shape({
        quote_id: PropTypes.string.isRequired,
        total_cost: PropTypes.number.isRequired,
    }),
};
export default withTranslation()(QuoteDetail);
